/**
 * Whispers - small fun facts about Megha that only her closest people
 * would know. Each one becomes a tiny dim star somewhere in her sky.
 *
 * Hover (don't click) to discover. The fact appears as a label at the
 * bottom of the screen. Discovered whispers persist and are listed in
 * the discovery panel.
 *
 * The voice is third person ("She ..."), short, observed, specific.
 */

export const WHISPERS = [
  { id: 'w1',  text: 'He who is happy is the winner' },
  { id: 'w2',  text: 'Jimmu, Ni Illa' },
  { id: 'w3',  text: 'Favorite movie - Project Hail Mary' },
  { id: 'w4',  text: 'She watches everything at 1.5x speed' },
  { id: 'w5',  text: 'Juju Baby' },
  { id: 'w6',  text: 'Hi, Question?' },
  { id: 'w7',  text: 'Desserts are her favorite part of the meal' },
  { id: 'w8',  text: 'She loves to flex her biceps' },
  { id: 'w9',  text: 'She doesn\'t like to miss any tourist spot on a trip' },
  { id: 'w10', text: 'Waaaaaaaooooooooowwwwww' },
  { id: 'w11', text: 'Coffee - Anyday, Anytime' },
  { id: 'w12', text: 'Current Designation - Skin Care Specialist' },
  { id: 'w13', text: 'Melle Da Sreee' },
  { id: 'w14', text: 'Jimmu Walk-inggggg' },
  { id: 'w15', text: 'Every Summer I turn Pretty' },
  { id: 'w16', text: 'Suga - Yes Please' },
  { id: 'w17', text: 'nolyeog-eun dangsin-eul baesinhaji anh-eul geos-ibnida' },
  { id: 'w18', text: 'Ende Da' },
  { id: 'w19', text: 'Aaramaadira?' },
  { id: 'w20', text: 'Whenever in doubt, Book Avis!' },
  { id: 'w21', text: 'So you see, that\'s where the trouble began. That smile. That damned smile' },
  { id: 'w22', text: 'I wish I could menstruate - Dwight Schrute' },
  { id: 'w23', text: 'Favorite Sandwich - Tretinoin Sandwich' },
  { id: 'w24', text: 'Next Goal - Hair Care Specialist' },
  { id: 'w25', text: 'Chuchi Gang Forever' },
  { id: 'w26', text: 'You are the absolute best' },
  { id: 'w27', text: '**Nose Flaring Signals**' },
  { id: 'w28', text: 'Malare, Ennuyaril vidarum panimalare' },
];
